// extracted by mini-css-extract-plugin
export default {"last-character":"App_last-character__KnvMD"};